export {}

require('./index.css')
